/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { useDateFormatter } from "@i18n/next";
import {
  Button,
  ChevronDownIcon,
  ModalDropdownMenu,
  numericPercentages,
  spacing,
} from "@packages/ui";
import { parse } from "date-fns";

import { isCustomDesktop, isLargeDevice } from "../bibleStyle.constants";
import { DailyReadingNavigator } from "./DailyReadingNavigator";

const scrollStyle: Interpolation = {
  maxHeight: "60vh",
  maxWidth: numericPercentages[100],
  padding: `0 ${spacing.m}`,
  [isCustomDesktop]: {
    maxWidth: "max(calc(7 * 64px + 2 * 48px), 33vw)",
  },
  [isLargeDevice]: {
    maxWidth: "max(calc(7 * 64px), 50vw)",
  },
};
const contentStyle: Interpolation = {
  maxWidth: "initial",
  padding: spacing.s,
};

export const DailyReadingNavigation = ({ date }) => {
  const parsedDate = parse(date, "yyyy-MM-dd", new Date());
  const format = useDateFormatter();

  return (
    <ModalDropdownMenu
      contentCSS={contentStyle}
      trigger={
        <Button variant="outline" endIcon={<ChevronDownIcon />}>
          {format(parsedDate, "LLL d")}
        </Button>
      }
    >
      <DailyReadingNavigator currentDate={parsedDate} css={scrollStyle} />
    </ModalDropdownMenu>
  );
};
